import { Skeleton } from "antd";
import styled from "styled-components";

export const StyledTitleSkeleton = styled(Skeleton.Input)`
  && {
    width: 220px;
    .ant-skeleton-input {
      width: 100%;
      height: 19px;
      margin-top: 3px;
    }
  }
`;
StyledTitleSkeleton.displayName = "StyledTitleSkeleton";

export const SkeletonContainer = styled.div`
  display: flex;
  gap: 32px;
  width: 100%;

  & > div {
    flex: 1;
  }
`;
SkeletonContainer.displayName = "SkeletonContainer";
